import api from "./api";

const idempotencyKey = () =>
  "treasury-" + Date.now() + "-" + Math.random().toString(16).slice(2);

const withIdempotency = (headers = {}) => ({
  headers: {
    ...headers,
    "Idempotency-Key": idempotencyKey(),
  },
});
const pendingTransferKey = "herrametal.pending-treasury-transfer.v1";
const getPendingTransfer = () => {
  const value = sessionStorage.getItem(pendingTransferKey);
  return value ? JSON.parse(value) : null;
};
const submitPendingTransfer = async pending => {
  try {
    const result = await api.post("/treasury/transfers", pending.payload, { headers: { "Idempotency-Key": pending.key } });
    sessionStorage.removeItem(pendingTransferKey);
    return result;
  } catch (error) {
    // A request that has lost its response must keep the original key and body.
    const message = String(error.response?.data?.error || error.response?.data?.message || "");
    const rejectedBeforeCommit = ["Importe inválido", "Fecha de transferencia inválida", "Las cuentas origen y destino deben ser distintas", "Cuenta origen o destino no encontrada", "Configurá las cuentas contables activas para origen y destino antes de transferir"].includes(message);
    if (!pending.uncertain && error.response?.status === 400 && rejectedBeforeCommit) sessionStorage.removeItem(pendingTransferKey);
    else { pending.uncertain = true; sessionStorage.setItem(pendingTransferKey, JSON.stringify(pending)); }
    throw error;
  }
};

export const treasuryService = {
  listAccounts() {
    return api.get("/treasury/accounts");
  },
  createAccount(payload) {
    return api.post("/treasury/accounts", payload, withIdempotency());
  },
  listMovements(params) {
    return api.get("/treasury/movements", { params });
  },
  createMovement(payload) {
    return api.post("/treasury/movements", payload, withIdempotency());
  },
  transfer(payload) {
    let pending = getPendingTransfer();
    if (pending && JSON.stringify(pending.payload) !== JSON.stringify(payload)) throw new Error("Hay una transferencia pendiente de recuperar antes de registrar otra.");
    if (!pending) {
      const bytes = new Uint8Array(16); window.crypto.getRandomValues(bytes);
      pending = { key: `treasury-${Array.from(bytes, x => x.toString(16).padStart(2, "0")).join("")}`, payload, uncertain: false };
      sessionStorage.setItem(pendingTransferKey, JSON.stringify(pending));
    }
    return submitPendingTransfer(pending);
  },
  pendingTransfer: getPendingTransfer,
  retryPendingTransfer() {
    const pending = getPendingTransfer();
    if (!pending) throw new Error("No hay una transferencia pendiente de recuperar.");
    return submitPendingTransfer(pending);
  },
  reconcile(id) {
    return api.post(`/treasury/movements/${id}/reconcile`, {}, withIdempotency());
  },
  listInstruments(params) {
    return api.get("/treasury/instruments", { params });
  },
  resolveInstrument(id, status, reason) {
    return api.post(`/treasury/instruments/${id}/status`, { status, reason }, withIdempotency());
  },
  rejectCheck(id, reason) {
    return api.post(`/treasury/instruments/${id}/reject`, { reason }, withIdempotency());
  },
  depositCheck(id, payload) { return api.post(`/treasury/instruments/${id}/deposit`, payload, withIdempotency()); },
  clearCheck(id, payload) { return api.post(`/treasury/instruments/${id}/clearance`, payload, withIdempotency()); },
};
